export enum RAVEN_PAGE_NAME {
    HOME = 'home',
    CONFIRMATION = 'confirmation',
    FlightSHOME = 'flights',
    FLIGHTS_HOME = 'flights_home',
    FLIGHTS_SRP = 'flights_srp',
    CLEARTRIP_HOME = 'cleartrip_home'
}

export enum RAVEN_COMMON_KEYS {
    PLATFORM = 'platform',
    LOGIN_STATUS = 'login_status',
    DOMAIN = 'domain',
    VERTICAL = 'vertical',
    PAGE_NAME = 'page_name',
    CURRENCY = 'currency',
    STATSTIG_AB_KEY = 'h_ab_key'
}

export enum RAVEN_EVENT_NAME {
    HOME_PAGELOAD = 'a_home_pageload',
    HOME_M_HOMEPAGE_LOAD = 'a_m_homepage_load',
    HOME_SEARCH_CLICK = 'a_hp_search_click',
    HOME_DEPARTURE_AIRPORT_SELECTED = 'a_hp_departure_airport_selected',
    HOME_ARRIVAL_AIRPORT_SELECTED = 'a_arrival_airport_selected',
    HOME_ARRIVAL_AIRPORT_NULL_SEARCH = 'a_hp_arrival_airport_null_search',
    HOME_DEPARTURE_AIRPORT_NULL_SEARCH = 'a_hp_departure_airport_null_search',
    HOME_RT_DATE_SELECTED = 'a_hp_rt_date_selected',
    HOME_OW_DATE_SELECTED = 'a_hp_ow_date_selected',
    HOME_RT_CALENDAR_OPENED = 'a_hp_rt_calendar_opened',
    HOME_OW_CALENDAR_OPENED = 'a_hp_ow_calendar_opened',
    HOME_PAX_UPDATED = 'a_hp_pax_updated',
    HOME_TRAVEL_CLASS_UPDATED = 'a_hp_travel_class_updated',
    HOME_PTC_ICON_HOVER = 'a_ptc_icon_hover',
    HOME_PTC_FARE_SELECTED = 'a_ptc_fare_selected',
    HOME_JOURNEY_CLICKED = 'a_select_journey_click',
    CFNR_LEARN_MORE_CLICK = 'h_cfnr_learn_more_click',
    LOGIN_CLICK = 'u_login_click',
    LOGIN_ERROR = 'u_login_error',
    LOGIN_SUCCESS = 'u_login_success',
    LOGIN_POPUP = 'u_login_popup',
    SRP_PAGELOAD = 'a_srp_pageload',
    SRP_FAILURE = 'a_pageload_failure',
    SRP_SEARCH_CLICK = 'a_srp_search_click',
    A_UI_ACTION = 'a_ui_action'
}

export enum 
RAVEN_ATTRIBUTE_NAME {
    HP_SEARCH_FLIGHT = 'search_flight_hp',
    HP_PTC_ICON_HOVER = 'ptc_icon_hover',
    HP_JOURNEY_CLICKED = 'a_select_journey_click',
    HP_DEPARTURE_AIRPORT_SELECTED = 'a_departure_airport_selected',
    HP_ARRIVAL_AIRPORT_SELECTED = 'a_arrival_airport_selected',
    HP_OW_CALENDAR_OPENED = 'a_ow_calendar_opened',
    HP_OW_DATE_SELECTED = 'a_ow_date_selected',
    HP_RT_CALENDAR_OPENED = 'a_rt_calendar_opened',
    HP_RT_DATE_SELECTED = 'a_rt_date_selected',
    HP_PAX_UPDATED = 'a_pax_updated',
    HP_TRAVEL_CLASS_UPDATED = 'a_travel_class_updated',
    HP_DEPARTURE_AIRPORT_NULL_SEARCH = 'a_departure_airport_null_search',
    HP_ARRIVAL_AIRPORT_NULL_SEARCH = 'a_arrival_airport_null_search',
    HP_EXPLORE_CLICK = 'a_hp_explore_click',
    HP_EXPLORE_MAP_CLICK = 'a_hp_explore_map_click',
    PAGE_LOADTIME = 'page_loadtime',
    SUPERCOIN_BALANCE = 'supercoin_balance',
    STUDENT_FARE_TOGGLE_ON = 'a_student_fare_toggle_on',
    STUDENT_FARE_TOGGLE_OFF = 'a_student_fare_toggle_off',
    UPGRADE_FARE_FAMILY_CLICK = 'upgrade_fare_family_option_clicked',
    STUDENT_FARE_LEARN_MORE_CLICK = 'a_student_fare_learn_more_click'
}

export enum MULTITRACKING_EVENT_NAME {
    ON_CLICK = 'onClick',
    ON_SCROLL = 'onScroll'
}

export const PTC_TAG_TYPE = {
    STUDENT_FARE: 'student',
    STUDENT_FARE_AVAILABLE: 'student_fare_available'
}
